
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0127f518\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./dsn.scss")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./dsn.ts"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0127f518\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dsn.vue.html"),
  /* scopeId */
  "data-v-0127f518",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dsn/dsn.vue.html
// module id = /Nrp
// module chunks = 2